import { Instance as SummaryInstance, MasterProduct } from '../types';

export const buildPatchProductBody = (
  instance: SummaryInstance,
  product_id: string,
  productToMap?: MasterProduct | null,
) => {
  const changes: any = {};
  const undo_changes: any = {};

  if (!productToMap) return { changes, undo_changes };

  changes[instance.product_id] = productToMap.product_id;
  changes['existingInstanceId'] = instance.product_id;
  changes['newInstanceId'] = productToMap.product_id;
  undo_changes[instance.product_id] = productToMap.product_id;

  if (!instance.references) return { changes, undo_changes };

  instance.references.product_components.forEach((product: any) => {
    changes[instance.product_id] = product_id;
    undo_changes[instance.product_id] = product_id;
  });
  instance.references.product_uses.forEach((product_use: any) => {
    changes[instance.product_id] = product_id;
    undo_changes[instance.product_id] = product_id;
  });
  return { changes, undo_changes };
};
